module.exports = __webpack_public_path__ + "media/images/pages/fcr/component-2-48dfd79ca5d43ac0940cbe39f97e2a9c.jpg";